var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97487 14.0024H13.0149C14.0415 14.0024 14.6815 12.8891 14.1682 12.0024L9.14821 3.32906C8.63487 2.4424 7.35487 2.4424 6.84154 3.32906L1.82154 12.0024C1.30821 12.8891 1.94821 14.0024 2.97487 14.0024ZM7.99487 9.33573C7.62821 9.33573 7.32821 9.03573 7.32821 8.66906V7.33573C7.32821 6.96906 7.62821 6.66906 7.99487 6.66906C8.36154 6.66906 8.66154 6.96906 8.66154 7.33573V8.66906C8.66154 9.03573 8.36154 9.33573 7.99487 9.33573ZM8.66154 12.0024H7.32821V10.6691H8.66154V12.0024Z",
    fill: "#FDC620"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.871ca9e0314b4c94f298039110aadc31.svg";
export { ForwardRef as ReactComponent };